<template lang="pug">
	div.slider
		div.swiper-container
			div.swiper-wrapper
				div.swiper-slide(v-for="slider in content.slider")
					div.slide-inner
						img(v-bind:src="slider.icon")
						h3 {{slider.copy}}
		div.swiper-pagination
		div.swiper-button-prev
		div.swiper-button-next
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
	name: 'Slider',
	props: ['content'],
	data() {
		return {
			slider: null,
			settings: {
				speed: 600,
				loop: false,
				slidesPerView: 5,
				spaceBetween: 0,
				autoHeight: true,
				pagination: {
					el: '.slider .swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.slider .swiper-button-next',
					prevEl: '.slider .swiper-button-prev'
				},
				breakpoints: {
					1100: {
						slidesPerView: 4
					},
					960: {
						slidesPerView: 3
					},
					560: {
						slidesPerView: 1
					}
				}
			}
		}
	},
	methods: {
		initSlider(){
			this.slider = new Swiper('.slider .swiper-container', this.settings);
		}
	},
	mounted() {
		this.initSlider();
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Slider/index.vue